/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { ReactNode } from 'react'
import { Button, Modal, ModalProps } from '@mantine/core'
import ButtonGroup from '../form/ButtonGroup'

export type ConfirmModalProps = ModalProps & {
  message: ReactNode
  onConfirm (): void
  title?: string
}

function ConfirmModal (props: ConfirmModalProps) {
  const {
    opened,
    message,
    onClose,
    onConfirm,
    title,
    ...others
  } = props

  const intl = useIntl()
  return (
    <Modal
      centered
      onClose={onClose}
      opened={opened}
      title={title || intl.formatMessage({
        id: 'confirmation',
        defaultMessage: 'Confirmation'
      })}
      {...others}
    >
      {message}

      <ButtonGroup>
        <Button onClick={onClose}>
          {intl.formatMessage({
            id: 'no',
            defaultMessage: 'Non'
          })}
        </Button>
        <Button
          variant="filled"
          onClick={onConfirm}
        >
          {intl.formatMessage({
            id: 'yes',
            defaultMessage: 'Oui'
          })}
        </Button>
      </ButtonGroup>
    </Modal>
  )
}

export default ConfirmModal
